import apiUrl from '../baseUrls/functions';
import AxiosService from '../axiosConfig/AxiosService';

export default new class TiersService {
    
    get = (callback, queryParams) => AxiosService.get(apiUrl('/api/crud/tiers/get'), callback, queryParams);
    getById = (id, callback) => AxiosService.get(apiUrl(`/api/crud/tiers/get/${id}`), callback);
    add = (data, callback) => AxiosService.post(apiUrl('/api/crud/tiers/add'), data, callback);
    update = (data, callback) => AxiosService.put(apiUrl('/api/crud/tiers/update'), data, callback);
    delete = (id, callback) => AxiosService.delete(apiUrl(`/api/crud/tiers/delete/${id}`), callback);
}